export const getKeyByValue = (targetValue: string, allValues: { [key: string]: string }) => {
  return Object.keys(allValues).find((key) => allValues[key] === targetValue)
}
